export const selectCourses = (state) => state.courses.all || [];
export const selectCurrentCourse = (state) => state.courses?.current || null;
export const selectIsLoading = (state) => state.courses.isLoading;
export const selectLastCourse = (state) => state.courses.last || null;
export const selectCoursesCount = (state) => state.courses.count || 0;
